import * as React from "react";
import { Box, Button, Grid, Pagination, Stack, Typography, useTheme } from "@mui/material";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import constants from "../../../utils/Constants";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { useState } from "react";
import { getSrchTypeTxt } from "../../../utils/format";
import { getApprProdsServ } from "../../../services/amtc-service";
import SearchTxtField from "../../../components/SearchTxtField";
import CustomDropDown from "../../../components/CustomDropDown";
import ProductCard from "../../../components/ProductCard";



function ProdApprWaitPg() {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = 12;
    const ddArr = [
        { value: "prodName", label: "Name" },
        { value: "amtcProdIdStrg", label: "AMTC Ref PID" }
    ]
    const type = "req";
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const searchType = searchParams.get("st") || ddArr[0].value;
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)


    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.apprProdList, pgNo, type, isSrchBtnClick],
        () => getApprProdsServ({ pageNumber: pgNo, searchKeyWord: searchWord, searchKeyType: searchType, limit, type }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });


    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    function handleViewClick() {
        navigate(route.aProdApprCreateList);
    };

    function handleProdCardClick(i) {
        navigate(`${route.aApprReqProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleDDChange(e) {
        setSearchParams(prev => {
            prev.set("st", e.target.value)
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };


    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }


    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Waiting For Product Approval List</Typography>



                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <Box mb={0.5}><SearchTxtField handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                        onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search Product By ${getSrchTypeTxt(ddArr, searchType)} .....`} /></Box>
                    <CustomDropDown height={30} width={140} handleDDChange={handleDDChange} ddArr={ddArr}  defaultValue={searchType ?? ddArr[0].value}  />
                </Stack>
                {ctxtUser?.userType === constants.admin && <Button variant='outlined' onClick={handleViewClick} sx={{
                    color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                }}>  Your Products Awaiting Approval</Button>}

            </Stack>

            <ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} handleCardClick={handleProdCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
            <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                    page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
            </Stack>
        </Box>
    );
}

export default ProdApprWaitPg;